module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.loading) ? _c('div', {
    staticClass: "loading loading-spacer",
    attrs: {
      "align": "center"
    }
  }, [_c('loading', {
    attrs: {
      "loading": _vm.loading
    }
  })], 1) : _c('div', {
    staticClass: "statistic-cards"
  }, [_c('div', {
    staticClass: "date-flag"
  }, [_vm._v("Hoje")]), _c('div', {
    staticClass: "card calls"
  }, [_c('span', {
    staticClass: "number"
  }, [_vm._v(_vm._s(_vm.calls_task || 0))]), _c('span', {
    staticClass: "card-label"
  }, [_vm._v("Ligações")]), _c('div', {
    staticClass: "separation-line"
  })]), _c('div', {
    staticClass: "card emails"
  }, [_c('span', {
    staticClass: "number"
  }, [_vm._v(_vm._s(_vm.email_task || 0))]), _c('span', {
    staticClass: "card-label"
  }, [_vm._v("e-mails")]), _c('div', {
    staticClass: "separation-line"
  })]), _c('div', {
    staticClass: "card linkedin"
  }, [_c('span', {
    staticClass: "number"
  }, [_vm._v(_vm._s(_vm.linkedin_task || 0))]), _vm._m(0), _c('div', {
    staticClass: "separation-line"
  })]), _c('div', {
    staticClass: "card social"
  }, [_c('span', {
    staticClass: "number"
  }, [_vm._v(_vm._s(_vm.social_task || 0))]), _vm._m(1), _c('div', {
    staticClass: "separation-line"
  })])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "card-label"
  }, [_vm._v("Contatos "), _c('br'), _vm._v(" via LinkedIn")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "card-label"
  }, [_vm._v("Contatos "), _c('br'), _vm._v(" via Social")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-622d2c06!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/manual_tasks/statistic_cards.vue
// module id = 1151
// module chunks = 1